module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_8.fd5975be.png";